import { render, staticRenderFns } from "./SettlementPage.vue?vue&type=template&id=23374637&scoped=true&"
import script from "./SettlementPage.vue?vue&type=script&lang=js&"
export * from "./SettlementPage.vue?vue&type=script&lang=js&"
import style0 from "./SettlementPage.vue?vue&type=style&index=0&id=23374637&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23374637",
  null
  
)

export default component.exports